import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrimInputDirective } from './directives/trim-input.directive';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from '@danielmoncada/angular-datetime-picker';
import { OwlMomentDateTimeModule, OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { QuillModule } from 'ngx-quill';
import { EditSpecimenKitComponent } from 'src/app/shared/edit-specimen-kit/edit-specimen-kit.component';
import {
  MultipleLinkedAccountdialogComponent
} from '../feature/manage-customer-users/multiple-linked-accountdialog/multiple-linked-accountdialog.component';
import { OrderCloseDialogComponent } from '../feature/order/order-close-dialog/order-close-dialog.component';
import { OrderPatientDialogComponent } from '../feature/order/order-patient-dialog/order-patient-dialog.component';
import { AckDialogComponent } from '../feature/results/ack-dialog/ack-dialog.component';
import { OrderReportDialogComponent } from '../feature/results/order-report-dialog/order-report-dialog.component';
import { ShareReportDialogComponent } from '../feature/results/share-report-dialog/share-report-dialog.component';
import { AnnouceBannerComponent } from './announcement/annouce-banner/annouce-banner.component';
import { BuLaSelectComponent } from './bu-la-select/bu-la-select.component';
import { ClindxTableFilterComponent } from './clindx-table-filter/clindx-table-filter.component';
import { ClindxTimepickerComponent } from './clindx-timepicker/clindx-timepicker.component';
import { ContactSupportComponent } from './contact-support/contact-support.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { DecimalvalidaitonDirective } from './directives/decimalvalidation.directive';
import { DisableUnauthorizedDirective } from './directives/disable-unauthorized.directive';
import { FloatFiveDigitsDirective } from './directives/float-five-digits.directive';
import { HoverLinkDirective } from './directives/hover-link.directive';
import { IsAuthorizedDirective } from './directives/is-authorized.directive';
import { KitIdFormatDirective } from './directives/kit-id-format.directive';
import { MaskKitIdDirective } from './directives/mask-kit-id.directive';
import { NumberDirective } from './directives/numbers-only.directive';
import { RouterOutletDirective } from './directives/router-outlet.directive';
import { CheckboxFormComponent } from './dynamic-form/checkbox-form/checkbox-form.component';
import { DatepickerFormComponent } from './dynamic-form/datepicker-form/datepicker-form.component';
import { DynamicFormFieldDirective } from './dynamic-form/dynamic-form-field.directive';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { InputCompComponent } from './dynamic-form/input-comp/input-comp.component';
import { InputNumCompComponent } from './dynamic-form/input-num-comp/input-num-comp.component';
import { RadioButtonFormComponent } from './dynamic-form/radio-button-form/radio-button-form.component';
import { SelectFormComponent } from './dynamic-form/select-form/select-form.component';
import { SelectSearchBoxComponent } from './dynamic-form/select-search-box/select-search-box.component';
import { FooterComponent } from './footer/footer.component';
import { LatestPolicyGuard } from './guards/latest-policy.guard';
import { HeaderPageComponent } from './header-page/header-page.component';
import { LegalInfoComponent } from './legal-info/legal-info.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './loader/loader.service';
import { MaterialModule } from './material/material.module';
import { ObsoleteBrowserBannerComponent } from './obsolete-browser-banner/obsolete-browser-banner.component';
import { PasswordExpiryDialogComponent } from './password-expiry-dialog/password-expiry-dialog.component';
import { PasswordPolicyComponent } from './password-policy/password-policy.component';
import { PasswordPolicyService } from './password-policy/password-policy.service';
import { PhonePipe } from './pipe/phone.pipe';
import { QuillEditorDialogComponent } from './quill-editor-dialog/quill-editor-dialog.component';
import { ResponsiveNavbarComponent } from './responsive-navbar/responsive-navbar.component';
import { DialogService } from './services/dialog.service';
import { DynamicFormServiceService } from './services/dynamic-form-service.service';
import { EnumService } from './services/enum.service';
import { NotificationService } from './services/notification-service';
import { TimePickerService } from './time-picker/time-picker-service';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ClindxMat2TableComponent } from './clindx-mat2-table/clindx-mat2-table.component';
import { OrderSpecimenDialogomponent } from '../feature/order/order-specimen-dialog/order-specimen-dialog.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import {
  MultiplePhysicianAddressDialogComponent
} from '../feature/order/order-physician/multiple-physician-address-dialog/multiple-physician-address-dialog.component';
import { ClindxFormTableComponent } from './clindx-form-table/clindx-form-table.component';
import { ClindxUploadComponent } from './clindx-upload/clindx-upload.component';
import { NpiDialogComponent } from './npi-dialog/npi-dialog.component';
import { PhysicianService } from './services/physician.service';
import { SmartyService } from './services/smarty.service';
import { DateTimePickerFormComponent } from './dynamic-form/date-time-picker-form/date-time-picker-form.component';
import { TimepickerFormComponent } from './dynamic-form/timepicker-form/timepicker-form.component';
import { OrderDynamicComponent } from './order-dynamic/order-dynamic.component';
import { OrderCheckboxFormComponent } from './order-dynamic/checkbox-form/checkbox-form.component';
import { OrderDateTimePickerFormComponent } from './order-dynamic/order-date-time-picker-form/order-date-time-picker-form.component';
import { OrderInputCompComponent } from './order-dynamic/input-comp/input-comp.component';
import { OrderInputNumCompComponent } from './order-dynamic/input-num-comp/input-num-comp.component';
import { OrderRadioButtonFormComponent } from './order-dynamic/radio-button-form/radio-button-form.component';
import { OrderSelectFormComponent } from './order-dynamic/select-form/select-form.component';
import { OrderSelectSearchBoxComponent } from './order-dynamic/select-search-box/select-search-box.component';
import { OrderDynamicDirective } from './order-dynamic/order-dynamic.directive';
import { OrderDatepickerFormComponent } from './order-dynamic/order-datepicker-form/order-datepicker-form.component';
import { PrintSpecimenDialogComponent } from '../feature/order/manage-package/print-specimen-dialog/print-specimen-dialog.component';
import { OrderTimepickerFormComponent } from './order-dynamic/timepicker-form/timepicker-form.component';
// Removed incompatible @angular-material-components/datetime-picker
// Using existing NgxMaterialTimepickerModule import from line 9
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { VirtualAutocompleteComponent } from './virtual-autocomplete/virtual-autocomplete.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DragDropFilesComponent } from './drag-drop-files/drag-drop-files.component';
import { ProgressBarComponent } from './drag-drop-files/progress-bar/progress-bar.component';
import { DndDirective } from './drag-drop-files/dragAndDrop.directive';
import { SampleSourceComponent } from './order-dynamic/sample-source/sample-source.component';
import { PrePrintedLabelDialogComponent } from './pre-printed-label-dialog/pre-printed-label-dialog.component';
import { ReceivingLabDropdownComponent } from './receiving-lab-dropdown/receiving-lab-dropdown.component';
import { TokenExpiryDialogComponent } from '../feature/account-management/token-expiry-dialog/token-expiry-dialog.component';
import { SelectSearchBoxApiComponent } from './order-dynamic/select-search-box-api/select-search-box-api.component';
import { OrderStatusBarComponent } from './order-status-bar/order-status-bar.component';
import { GraphDialogComponent } from './clindx-mat2-table/graph-dialog/graph-dialog/graph-dialog.component';
import { NgChartsModule } from 'ng2-charts';
import { SlickCarouselModule } from 'ngx-slick-carousel';

export const OWL_MOMENT_DATE_TIME_FORMATS = {
  parseInput: 'MM/DD/YYYY hh:mm A',
  fullPickerInput: 'MM/DD/YYYY hh:mm A',
  datePickerInput: 'MM/DD/YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
    declarations: [
        ToolbarComponent,
        FooterComponent,
        IsAuthorizedDirective,
        PhonePipe,
        NumberDirective,
        DisableUnauthorizedDirective,
        LoaderComponent,
        MultipleLinkedAccountdialogComponent,
        PasswordPolicyComponent,
        OrderReportDialogComponent,
        LegalInfoComponent,
        OrderCloseDialogComponent,
        OrderPatientDialogComponent,
        MultiplePhysicianAddressDialogComponent,
        ContactSupportComponent,
        ServerErrorComponent,
        AckDialogComponent,
        ShareReportDialogComponent,
        DynamicFormComponent,
        SelectFormComponent,
        RadioButtonFormComponent,
        CheckboxFormComponent,
        DatepickerFormComponent,
        InputCompComponent,
        DynamicFormFieldDirective,
        InputNumCompComponent,
        ResponsiveNavbarComponent,
        PasswordExpiryDialogComponent,
        RouterOutletDirective,
        DateRangeComponent,
        AnnouceBannerComponent,
        ClindxTableFilterComponent,
        TimePickerComponent,
        ClindxTimepickerComponent,
        SelectSearchBoxComponent,
        ObsoleteBrowserBannerComponent,
        HoverLinkDirective,
        QuillEditorDialogComponent,
        BuLaSelectComponent,
        FloatFiveDigitsDirective,
        DecimalvalidaitonDirective,
        KitIdFormatDirective,
        MaskKitIdDirective,
        HeaderPageComponent,
        EditSpecimenKitComponent,
        ClindxMat2TableComponent,
        OrderSpecimenDialogomponent,
        ClindxFormTableComponent,
        ClindxUploadComponent,
        NpiDialogComponent,
        DateTimePickerFormComponent,
        TimepickerFormComponent,
        DatepickerFormComponent,
        OrderDynamicComponent,
        OrderDynamicDirective,
        OrderCheckboxFormComponent,
        OrderDatepickerFormComponent,
        OrderInputCompComponent,
        OrderInputNumCompComponent,
        OrderRadioButtonFormComponent,
        OrderSelectFormComponent,
        OrderSelectSearchBoxComponent,
        OrderDateTimePickerFormComponent,
        OrderDatepickerFormComponent,
        PrintSpecimenDialogComponent,
        OrderTimepickerFormComponent,
        VirtualAutocompleteComponent,
        ConfirmDialogComponent,
        DragDropFilesComponent,
        ProgressBarComponent,
        DndDirective,
        SampleSourceComponent,
        PrePrintedLabelDialogComponent,
        ReceivingLabDropdownComponent,
        TokenExpiryDialogComponent,
        SelectSearchBoxApiComponent,
        OrderStatusBarComponent,
        GraphDialogComponent
    ],
    exports: [
        CommonModule,
        PhonePipe,
        ToolbarComponent,
        FooterComponent,
        NumberDirective,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        IsAuthorizedDirective,
        //MatDatepickerModule,
        //SatNativeDateModule,
        LoaderComponent,
        PasswordPolicyComponent,
        FlexLayoutModule,
        ResponsiveNavbarComponent,
        DynamicFormComponent,
        PasswordExpiryDialogComponent,
        PlatformModule,
        RouterOutletDirective,
        DateRangeComponent,
        ClindxTableFilterComponent,
        ClindxTimepickerComponent,
        TrimInputDirective,
        ObsoleteBrowserBannerComponent,
        HoverLinkDirective,
        FloatFiveDigitsDirective,
        DecimalvalidaitonDirective,
        NgxMaterialTimepickerModule,
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        KitIdFormatDirective,
        MaskKitIdDirective,
        HeaderPageComponent,
        ClindxMat2TableComponent,
        DatePipe,
        ClindxFormTableComponent,
        ClindxUploadComponent,
        NpiDialogComponent,
        OrderDynamicComponent,
        OrderDynamicDirective,
        VirtualAutocompleteComponent,
        ScrollingModule,
        ExperimentalScrollingModule,
        DragDropFilesComponent,
        ProgressBarComponent,
        ReceivingLabDropdownComponent,
        TokenExpiryDialogComponent,
        OrderStatusBarComponent,
        NgChartsModule,
        SlickCarouselModule
    ],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TrimInputDirective,
        //MatDatepickerModule,
        //SatNativeDateModule,
        FlexLayoutModule,
        //MatCarouselModule.forRoot(),
        NgxMaterialTimepickerModule,
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        QuillModule,
        MatMomentDateModule,
        ScrollingModule,
        ExperimentalScrollingModule,
        NgChartsModule,
        SlickCarouselModule
    ],
    providers: [
        EnumService,
        NotificationService,
        DialogService,
        LoaderService,
        PasswordPolicyService,
        LatestPolicyGuard,
        TimePickerService,
        DynamicFormServiceService,
        DatePipe,
        PhysicianService,
        SmartyService,
        { provide: OWL_DATE_TIME_FORMATS, useValue: OWL_MOMENT_DATE_TIME_FORMATS },
        { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { parseStrict: true, useUtc: false } }
    ]
})

export class SharedModule { }
